import { useHttp } from "../http/useHttp";
import { paths } from "../generated-types";
import { useDefaultError } from "@synota-io/synota-shared-ui";
import { useAxiosMfaMutation } from "../http/useAxiosMfaMutation";

type DeleteContractOperation =
  paths["/dashboard/synota/contracts/{contract_shared_uuid}/delete"]["post"];
export type UseContractDeleteInput = DeleteContractOperation["parameters"]["path"] &
  DeleteContractOperation["requestBody"]["content"]["application/json"];

export const useContractDelete = () => {
  const { client } = useHttp();

  const { isPending, status, data, error, mutate } = useAxiosMfaMutation<
    void,
    UseContractDeleteInput
  >({
    mutationKey: ["delete-contract"],
    mutationFn: ({ contract_shared_uuid, ...input }) =>
      client.post(`/synota/contracts/${contract_shared_uuid}/delete`, input),
  });

  useDefaultError(error, "Failed to delete contract");

  return { deleteContract: mutate, isPending, status, data, error };
};

export type UseContractDeleteReturn = ReturnType<typeof useContractDelete>;
